import React, { FunctionComponent } from "react";

import styled from "@mui/material/styles/styled";

import { Row, StackProps } from "@rui/Stack";

type FilterCountChipProps = StackProps & { size?: "sm" | "md" };

export const FilterCountChip = styled<FunctionComponent<FilterCountChipProps>>(
  ({ size: _, ...props }) => <Row variant="center" {...props} />
)(({ size = "md", theme }) => ({
  marginLeft: theme.spacing(1),
  backgroundColor: theme.palette.shades.primary[500],
  height: "18px",
  width: "18px",
  color: "#FFF",
  fontSize: size === "sm" ? "12px" : "14px",
  borderRadius: "4px",
}));

export default FilterCountChip;
